import palette from '../palette';

const MuiDataGrid = {
  defaultProps: {
    component: 'div',
    labelRowsPerPage: 'Rows per page',
    showFirstButton: true,
    showLastButton: true,
  },
  styleOverrides: {
    root: {
      '.MuiInputBase-root': {
        '@media max-width(900px)': {
          margin: 0,
        },
        margin: '0 32px 0 16px',
      },
      '@media max-width(900px)': {
        padding: '0 16px',
      },
      backgroundColor: palette.surface.light,
      justifyContent: 'space-between',
      padding: 'unset',
      // position: 'fixed', // this breaks layout!
      right: 0,
      width: '100%',
    },
    select: {
      lineHeight: '22px',
    },
    spacer: {
      '@media max-width(900px)': {
        display: 'none',
      },
      display: 'unset',
    },
    toolbar: {
      '.MuiTablePagination-actions': {
        '& .MuiButtonBase-root:not([disabled])': {
          color: palette.primary.main,
        },
        '@media max-width(900px)': {
          marginLeft: 0,
        },
        marginLeft: 16,
      },
      '@media max-width(900px)': {
        justifyContent: 'space-between',
        margin: '0 0 0 auto',
        maxWidth: 400,
      },
      justifyContent: 'unset',
      margin: 'unset',
      maxWidth: 'unset',
      padding: '0 16px',
    },
  },
};

export default MuiDataGrid;
